import { useCallback, useContext, useEffect, useState } from "react";
import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoaderContext } from "../../../../Services/Loader_Provider_Service/LoadingContext";
import { TostMsg } from "../../../../App";
import { getEmployeeKeys } from "../../EmployeeList/Service/employeeService";
import DynamicEmployeeForm from "../../EmployeeList/DynamicEmployeeForm";

const Statutory = (params) => {
  const { employeeAllData, employeeKeyDeta, updateEmployeeDetails } = params;
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [employeeCreate, setEmployeeCreate] = useState(false);
  const toster = useContext(TostMsg);
  const [employeeStatutoryData, setEmployeeStatutoryData] = useState([]);
  const [backButtonHide, setBackButtonHide] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [noData, setNoData] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");

  useEffect(() => {
    permissionAccouncementList();
    GetMasterSystemAlertList("Employee_MissingInfo_Message", 1);

    if (employeeKeyDeta) {
      let statutoryForm = employeeKeyDeta?.filter(
        (item) => item.KeyCategoryName == "Statutory"
      );
      setEmployeeStatutoryData(statutoryForm);
    }
  }, [employeeKeyDeta]);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Employee.Create") {
        setEmployeeCreate(true);
      }
    });
  };

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setNoData(msg?.Desc);
      }
    });
  }, []);

  const handleClick = () => {
    updateEmployeeDetails();
  };

  const renderForm = (type) => {
    if (type == "profile") {
      const tabTriggerEl = document.querySelector('a[href="#my-posts"]');
      handleClick();
      setIsEditing(false);
      if (tabTriggerEl) {
        const tab = new window.bootstrap.Tab(tabTriggerEl);
        tab.show();
      }
    }
  };

  return (
    <div className="documentdiv">
      <form id="Account-form">
        <div className="">
          <h4 className="text-primary mb-3 sumh4">Statutory</h4>

          {!isEditing ? (
            <div className="address-actionbtns">
              <span
                className="edit-btncss mb-2 love-icon"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Edit"
                onClick={() => setIsEditing(true)}
              >
                <LazyImage src="/images/org-img/edit.png" className="w-100" />
              </span>
            </div>
          ) : (
            <div className="address-actionbtns">
              <span
                className="edit-btncss mb-2 love-icon"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Cancel"
                onClick={() => {
                  setIsEditing(false);
                }}
              >
                <LazyImage
                  src="/images/org-img/profile/close.png"
                  className="w-100"
                />
              </span>
            </div>
          )}
          {!isEditing && (
            <>
              <div className="row">
                {employeeAllData[0]?.EmpKeyValues?.filter(
                  (value) => value?.KeyCategoryName === "Statutory"
                ).length === 0 ? (
                  <div style={{ textAlign: "center" }}>{noData}</div>
                ) : (
                  employeeAllData[0]?.EmpKeyValues?.map((data, index) => {
                    if (data?.KeyCategoryName === "Statutory") {
                      return (
                        <div className="col-lg-6 mb-2" key={index}>
                          <div className="innerform-grp">
                            <label>{data?.KeyDesc}</label>
                            <input
                              disabled={!isEditing}
                              type="text"
                              name="address1"
                              className={"form-control"}
                              value={data?.InferredValue || ""}
                            />
                          </div>
                        </div>
                      );
                    } else {
                      return null;
                    }
                  })
                )}
              </div>
            </>
          )}

          {isEditing && (
            <div className="statutory">
              <div className="">
                {employeeStatutoryData.length > 0 && (
                  <DynamicEmployeeForm
                    employeeKeyDeta={employeeStatutoryData}
                    employeeEditDetails={employeeAllData}
                    renderForm={renderForm}
                    backButtonHideStatus={backButtonHide}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default Statutory;
